import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/providers/AuthProvider';

const ORG_ADMIN_ROLES = ['ADMIN', 'OWNER'];

function isOrgAdmin(role?: string | null): boolean {
  return ORG_ADMIN_ROLES.includes((role ?? '').toUpperCase());
}

/**
 * Protects pages that belong to a single organization and should only be
 * reachable by that org's own Owner/Admin — Team, API Keys, Organization
 * settings, White Label, Subscription. This is an org-role check, not a
 * platform-admin check: every organization's own Owner is expected to pass
 * it. For founder-only, cross-tenant tooling (/app/admin/*) use AdminGuard
 * instead, which checks platform-admin identity rather than org role.
 */
export function OrgAdminGuard() {
  const { organization, isLoading } = useAuth();

  if (isLoading) return null;

  if (!isOrgAdmin(organization?.role)) {
    return <Navigate to="/app/dashboard" replace />;
  }

  return <Outlet />;
}
